import {
  Counts,
  DailyReport,
  DailyReportOrder,
  Driver,
  PaymentType,
  Payments,
} from "../../../models";

export const getDailyReport = (data: any): DailyReport => {
  return {
    deliveries: {
      counts: getCounts(data.deliveries.counts),
      payments: getPayments(data.deliveries.payments),
    },
    pickups: {
      counts: getCounts(data.pickups.counts),
    },
    drivers: data.drivers.map(getDriver),
    orders: data.orders.map(getDailyReportOrder),
  };
};

export const getCounts = (data: any): Counts => {
  return {
    canceled: {
      total: data.canceled.total,
      ids: data.canceled.ids,
    },
    complete: {
      total: data.complete.total,
      ids: data.complete.ids,
    },
    scheduled: {
      total: data.scheduled.total,
      ids: data.scheduled.ids,
    },
  };
};

export const getPayments = (data: any): Payments => {
  return {
    [PaymentType.CARD]: {
      total: data.card?.total || 0,
      ids: data.card?.ids || [],
    },
    [PaymentType.CASH]: {
      total: data.cash?.total || 0,
      ids: data.cash?.ids || [],
    },
    [PaymentType.CHECK]: {
      total: data.check?.total || 0,
      ids: data.check?.ids || [],
    },
    [PaymentType.VENMO]: {
      total: data.venmo?.total || 0,
      ids: data.venmo?.ids || [],
    },
    [PaymentType.PAYPAL]: {
      total: data.paypal?.total || 0,
      ids: data.paypal?.ids || [],
    },
    [PaymentType.OWES]: {
      total: data.owes?.total || 0,
      ids: data.owes?.ids || [],
    },
    [PaymentType.ACH]: {
      total: data.ach?.total || 0,
      ids: data.ach?.ids || [],
    },
    [PaymentType.CASH_APP]: {
      total: data.cash_app?.total || 0,
      ids: data.cash_app?.ids || [],
    },
    [PaymentType.ZELLE]: {
      total: data.zelle?.total || 0,
      ids: data.zelle?.ids || [],
    },
    [PaymentType.APPLE_CASH]: {
      total: data.apple_cash?.total || 0,
      ids: data.apple_cash?.ids || [],
    },
  };
};

export const getDriver = (data: any): Driver => {
  return {
    id: data.id,
    name: data.name,
    onClock: data.on_clock,
    status: data.status,
  };
};

export const getDailyReportOrder = (data: any): DailyReportOrder => {
  return {
    id: data.id,
    driverId: data.driver_id,
    customerName: data.customer_name,
    address: data.address,
    paymentType: data.payment_type,
  };
};
